import React from 'react';

export default function InfoBlock({
  icon,
  title,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className='space-y-4 md:space-y-6'>
      <div className='flex items-center gap-3'>
        {icon}
        <h2 className='text-foreground font-semibold'>{title}</h2>
      </div>
      <section className='grid grid-cols-1 gap-6 text-sm lg:grid-cols-2'>
        {children}
      </section>
    </section>
  );
}
